import utils from '../utils';

export default function extendTagModel(model) {
  const result = { ...model };

  result.type = 'tag';
  result.displayName = `${result.name} (${result.type})`;
  result.searchValue = result.displayName;
  result.normalizedDisplayName = utils.normalizeString(result.displayName);
  result.sorting = utils.normalizeString(result.name);

  return result;
}
